import { render, staticRenderFns } from "./get-discounts.vue?vue&type=template&id=47b2bb30&scoped=true"
import script from "./get-discounts.vue?vue&type=script&lang=js"
export * from "./get-discounts.vue?vue&type=script&lang=js"
import style0 from "./get-discounts.vue?vue&type=style&index=0&id=47b2bb30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b2bb30",
  null
  
)

export default component.exports